(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e7e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e7e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kJxWi", function(module, exports) {

$parcel$export(module.exports, "TestMic", function () { return $f182563ae7b1cb91$export$a131b61ceae72f7a; });
//import { setCanvasData } from './webdictaphone_ui'
/* SOURCE: https://github.com/mdn/dom-examples/blob/main/media/web-dictaphone */ const $f182563ae7b1cb91$var$gainSlider = document.getElementById("gainSliderTestMic");
const $f182563ae7b1cb91$var$indicator = document.getElementById("volume-indicator");
class $f182563ae7b1cb91$export$a131b61ceae72f7a {
    init(recordGainNode, audioctxt) {
        this.recordGainNode = recordGainNode;
        this.audioCtxTestMic = audioctxt;
        this.getUserMediaOnSuccess();
    }
    getUserMediaOnSuccess() {
        const micGain = localStorage.getItem("micgain");
        this.CURRENT_GAIN_TEST_MIC = micGain ? parseInt(micGain) : this.CURRENT_GAIN_TEST_MIC;
        this.analyser = this.audioCtxTestMic.createAnalyser();
        //this.analyser.fftSize = 2048
        this.recordGainNode.connect(this.analyser);
        this.drawVolumeter();
        //this.drawWaveForm()
        this.uiHandlers();
    }
    drawWaveForm() {
        const me = this;
        const bufferLength = this.analyser.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);
        this.analyser.getByteTimeDomainData(dataArray);
        setCanvasData(bufferLength, dataArray);
        requestAnimationFrame(()=>{
            me.drawWaveForm();
        });
    }
    drawVolumeter() {
        const me = this;
        const peak = this.getPeakLevel();
        $f182563ae7b1cb91$var$indicator.style.width = `${peak * 100}%`;
        requestAnimationFrame(()=>{
            me.drawVolumeter();
        });
    }
    getPeakLevel() {
        const array = new Uint8Array(this.analyser.fftSize);
        this.analyser.getByteTimeDomainData(array);
        return array.reduce((max, current)=>Math.max(max, Math.abs(current - 127)), 0) / 128;
    }
    async connectSource() {
        this.analyser.connect(this.audioCtxTestMic.destination);
    }
    disconnectSource() {
        this.analyser.disconnect();
    }
    uiHandlers() {
        const me = this;
        $("#testMicrophoneModal").on("show.bs.modal", (event)=>{
            $f182563ae7b1cb91$var$gainSlider.value = me.CURRENT_GAIN_TEST_MIC;
            document.getElementById("current-input-gain-test-mic").value = me.CURRENT_GAIN_TEST_MIC;
        });
        $("#testMicrophoneModal").on("hide.bs.modal", async (event)=>{
            me.analyser.disconnect();
        });
        $f182563ae7b1cb91$var$gainSlider.addEventListener("input", function() {
            const newGainValue = parseFloat(this.value);
            me.CURRENT_GAIN_TEST_MIC = newGainValue;
            me.recordGainNode.gain.value = newGainValue;
            localStorage.setItem("micgain", newGainValue);
            document.getElementById("current-input-gain-test-mic").value = newGainValue;
        });
    }
    constructor(){
        this.CURRENT_GAIN_TEST_MIC = 1;
        this.audioCtxTestMic = null;
        this.analyser = null;
        this.recordGainNode = null;
    }
}

});


parcelRequire("kJxWi");
})();
//# sourceMappingURL=composition.b143686a.js.map
